import { render, staticRenderFns } from "./DiagnosticsDataTable.vue?vue&type=template&id=a7e8009a&scoped=true&"
import script from "./DiagnosticsDataTable.vue?vue&type=script&lang=js&"
export * from "./DiagnosticsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./DiagnosticsDataTable.vue?vue&type=style&index=0&id=a7e8009a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7e8009a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VBtn,VChip,VContainer,VDataTable,VIcon,VPagination})
